<template>
  <div v-show="jumpList.length === 1" class="btn btn__green" @click="jumpAdd({ options_ids: [] })">
    <div><i class="kp-panel-jump"></i> {{$t('edit.sidebar.add_jump')}}</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    jumpList: 'jumpList',
  }),
  methods: mapActions([
    'jumpAdd',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** AddFirst.vue?66897cc6
 **/